import { AssessmentEditTemplate } from "app/features/assessments/templates/AssessmentEditTemplate";
import { ScrollView } from "react-native";

export default function AssessmentAddPage() {
  return (
    <ScrollView
      className={"flex-1"}
      contentContainerClassName="px-dashboard flex-1"
    >
      <AssessmentEditTemplate />
    </ScrollView>
  );
}
